import { Layout, TimeDomain as TimeDomainComponent } from "components"
export const TimeDomain = () => {
 return (
  <Layout>
   <TimeDomainComponent />
  </Layout>
 )
}
